const LAST_CONVERSATION_KEY = 'assistant:lastConversationId';

export const getLastConversationId = (): number | null => {
	try {
		const val = localStorage.getItem(LAST_CONVERSATION_KEY);
		return val ? Number(val) : null;
	} catch {
		return null;
	}
};

export const setLastConversationId = (id: number | null): void => {
	try {
		if (id) {
			localStorage.setItem(LAST_CONVERSATION_KEY, String(id));
		} else {
			localStorage.removeItem(LAST_CONVERSATION_KEY);
		}
	} catch {
		/* localStorage unavailable */
	}
};
